'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _LinkWrapper = require('../Link/LinkWrapper');

var _DefaultLinkComponent = require('../Link/DefaultLinkComponent');

var _TabStyled = require('./styles/TabStyled');

var _TabContentWrapperStyled = require('./styles/TabContentWrapperStyled');

var _TabContentStyled = require('./styles/TabContentStyled');

var _TabTextStyled = require('./styles/TabTextStyled');

var _TabIconStyled = require('./styles/TabIconStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  /**
   * Href that will be passed to Link inside Tab
   */
  linkHref: _propTypes2.default.string,

  /**
   * Determines whether to disable Tab
   */
  disabled: _propTypes2.default.bool,

  /**
   * Determines whether Tab is selected
   */
  isSelected: _propTypes2.default.bool,

  /**
   * Text that will be displayed on Tab
   */
  text: _propTypes2.default.string,

  /**
   * Number of Tab
   */
  index: _propTypes2.default.number,

  /**
   * Color scheme of Tab
   */
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),

  /**
    * Specify link component
    */
  linkComponent: _propTypes2.default.func,

  /**
   * Icon that will be rendered on Tab (see IconSvg or IconCustom props)
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

  /**
   * Specify function that will be called on Tab selection
   */
  onSelect: _propTypes2.default.func
};
var defaultProps = {
  linkHref: '',
  disabled: false,
  isSelected: false,
  text: '',
  index: 0,
  colorScheme: 'dark',
  linkComponent: _DefaultLinkComponent.DefaultLinkComponent,
  icon: null,
  onSelect: _reactackleCore.noop
};

var Tab = function (_Component) {
  _inherits(Tab, _Component);

  function Tab(props) {
    _classCallCheck(this, Tab);

    var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, props));

    _this._handleClick = _this._handleClick.bind(_this);
    return _this;
  }

  _createClass(Tab, [{
    key: '_handleClick',
    value: function _handleClick() {
      if (!this.props.disabled) {
        this.props.onSelect({
          index: this.props.index
        });
      }
    }
  }, {
    key: '_renderTabIcon',
    value: function _renderTabIcon() {
      var icon = this.props.icon;
      if (!icon) return null;
      var iconElement = void 0;

      if (typeof this.props.icon === "function") {
        var Icon = this.props.icon;
        iconElement = _react2.default.createElement(Icon, null);
      } else {
        iconElement = this.props.icon;
      }

      return _react2.default.createElement(_TabIconStyled.TabIconStyled, {
        colorScheme: this.props.colorScheme,
        selected: this.props.isSelected
      }, iconElement);
    }
  }, {
    key: '_renderTabTxt',
    value: function _renderTabTxt() {
      if (!this.props.text) return null;
      return _react2.default.createElement(_TabTextStyled.TabTextStyled, {
        hasIcon: this.props.icon !== null
      }, this.props.text);
    }
  }, {
    key: '_renderTabContent',
    value: function _renderTabContent() {
      var _props = this.props,
          disabled = _props.disabled,
          linkHref = _props.linkHref,
          linkComponent = _props.linkComponent,
          text = _props.text,
          tabIcon = this._renderTabIcon(),
          tabTxt = this._renderTabTxt();

      var tabContent = _react2.default.createElement(_TabStyled.TabStyled, {
        onClick: this._handleClick,
        colorScheme: this.props.colorScheme,
        selected: this.props.isSelected
      }, _react2.default.createElement(_TabContentWrapperStyled.TabContentWrapperStyled, null, _react2.default.createElement(_TabContentStyled.TabContentStyled, null, tabIcon, tabTxt)));

      if (!disabled && linkHref) {
        return _react2.default.createElement(_LinkWrapper.LinkWrapper, {
          linkComponent: linkComponent,
          href: linkHref,
          title: text
        }, tabContent);
      }

      return tabContent;
    }
  }, {
    key: 'render',
    value: function render() {
      return this._renderTabContent();
    }
  }]);

  return Tab;
}(_react.Component);

exports.default = Tab;
Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;
Tab.displayName = 'Tab';